// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "RLM 300",
    appLogoImage: require("@src/assets/images/liscr_logo.png"),
    successStatusImage: require("@src/assets/images/success_status.png"),
    errorStatusImage: require("@src/assets/images/error_status.png"),
    IMOCONV: require("@src/assets/images/IMOCONV.png"),
    ziploader: require("@src/assets/images/loader.gif")
  },
  navicons: {
    dashboard: require("@src/assets/images/nav_icons/dashboard_icon_black.png"),
    dashboard1: require("@src/assets/images/nav_icons/dashboard_icon.png"),

    rlm: require("@src/assets/images/nav_icons/dashboard_icon_black.png"),
    rlm1: require("@src/assets/images/nav_icons/dashboard_icon.png"),

    qb: require("@src/assets/images/nav_icons/dashboard_icon_black.png"),
    qb1: require("@src/assets/images/nav_icons/dashboard_icon.png"),

    kpi: require("@src/assets/images/nav_icons/kpi_light.png"),
    kpi1: require("@src/assets/images/nav_icons/kpi_dark1.png"),

    Search: require("@src/assets/images/nav_icons/search_icon_01.png"),
    Search1: require("@src/assets/images/nav_icons/search_icon.png"),

    library: require("@src/assets/images/nav_icons/folder_icon1.png"),
    library1: require("@src/assets/images/nav_icons/folder_icon1.png"),

    appSettings: require("@src/assets/images/nav_icons/appSettings.png"),
    appSettings1: require("@src/assets/images/nav_icons/appSettings_01.png"),

    subscriptions: require("@src/assets/images/nav_icons/sub_icon.png"),
    subscriptions1: require("@src/assets/images/nav_icons/sub_icon.png"),

    registry: require("@src/assets/images/nav_icons/kr_01.png"),
    registry1: require("@src/assets/images/nav_icons/kr_logo_new.png"),

    Profile: require("@src/assets/images/nav_icons/account_icon_01.png"),
    Profile1: require("@src/assets/images/nav_icons/account_icon.png"),

    dlibrary: require("@src/assets/images/nav_icons/folder_black.png"),
    logout: require("@src/assets/images/navicons/user_profile.png"),
    notification: require("@src/assets/images/navicons/notification.svg"),
    user: require("@src/assets/images/navicons/user_profile.png"),

    rotate: require("@src/assets/images/nav_icons/rotate-right.png"),
    more: require("@src/assets/images/nav_icons/more.png"),
    rotate1: require("@src/assets/images/nav_icons/rotate_right1.png"),
    more1: require("@src/assets/images/nav_icons/more1.png"),
    invoice: require("@src/assets/images/nav_icons/invoice.png"),
    Right_Tick: require("@src/assets/images/nav_icons/Right_Tick.png"),
    Chat_Bot: require("@src/assets/images/nav_icons/chatbot.png")
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
